import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-project-management',
  templateUrl: './project-management.component.html',
  styleUrls: ['./project-management.component.scss']
})
export class ProjectManagementComponent implements OnInit {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'IT Programme & Project Management Services | DotBlack',
      description: 'Plan and deliver complex technology initiatives with structured programme, project, risk, quality and supplier management.',
      path: '/project-management/',
      type: 'website',
      schema: { '@context': 'https://schema.org', '@type': 'Service', name: 'Programme & Project Management', provider: { '@type': 'Organization', name: 'DotBlack Projex Pty (Ltd)', url: 'https://dotblack.co.za/' }, url: 'https://dotblack.co.za/project-management/' }
    });
  }
}
